import { Component, Inject } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';
import { Constants } from '../../constants';
import { ConfirmationDialogConfig } from '../../models';
import { AppToasterService } from '../../services';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss',
  providers: [provideNativeDateAdapter()]
})
export class ConfirmationDialogComponent {
  reason!: string;
  price!: number | undefined;
  lastLessonDate = new Date();
  maxDate = moment().endOf('month').toDate();
  minDate = new Date();

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    private readonly toasterService: AppToasterService,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogConfig | null
  ) {
    this.price = this.data?.price;
    if (this.data?.maxDate) {
      this.maxDate = this.data.maxDate;
    }
  }

  onConfirm(): void {
    this.dialogRef.close({ isConfirmed: true, reason: this.reason, price: this.price, lastLessonDate: this.lastLessonDate });
  }

  onCancel(): void {
    this.dialogRef.close({ isConfirmed: false });
  }

  checkAmount(): void {
    if (!this.data?.price || !this.price) {
      return;
    }
    if (this.price > this.data?.price || this.price < 0) {
      this.price = this.data?.price;
      this.toasterService.error(Constants.errorMessages.priceValidation.replace('{price}', this.data?.price.toString()));
    }
  }
}
